export const comparisonOptions = [
  'None',
  'Before Measurement',
  'Comparison Site',
  'Literature Value',
  'International'
]

export const unitOptions = ['m²', 'km²', 'ha', 'other']
